import { DimensionDrawingRenderer } from 'app/modules/wallforming/components/scenes/objects/dimensions/DimensionDrawingRenderer';
import { useDimensionDrawing } from 'app/modules/wallforming/components/scenes/objects/dimensions/hooks/useDimensionDrawing';

import type { DimensionElementTypes } from 'app/modules/wallforming/components/scenes/objects/dimensions/core/dimensionScene';
import type { Vector3 } from 'three';

interface FaceDimensionProps {
    elementTypes: DimensionElementTypes;
    mid: Vector3;
    selectedPoiIndex: number;
}

/** Wall POI dimensioning: wall outline, panels, accessories, labels and dimension chains in one drawing. */
export const FaceDimension = ({ elementTypes, mid, selectedPoiIndex }: FaceDimensionProps) => {
    const result = useDimensionDrawing(selectedPoiIndex, mid, elementTypes);
    if (!result) {
        return null;
    }

    return <DimensionDrawingRenderer drawing={result.drawing} frame={result.frame} mapping={result.mapping} />;
};
